import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbsProps {
  items: Crumb[];
  tone?: "dark" | "light";
}

export default function Breadcrumbs({ items, tone = "dark" }: BreadcrumbsProps) {
  const listClass = tone === "light" ? "text-background-400" : "text-foreground-500";
  const linkClass =
    tone === "light"
      ? "hover:text-background-50 transition-colors cursor-pointer"
      : "hover:text-primary-600 transition-colors cursor-pointer";
  const currentClass = tone === "light" ? "text-background-100" : "text-foreground-800";
  const sepClass = tone === "light" ? "text-background-600" : "text-foreground-300";

  return (
    <nav aria-label="面包屑导航" className="text-sm">
      <ol className={`flex flex-wrap items-center gap-2 ${listClass}`}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.label} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className={linkClass}>
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? currentClass : ""} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast && <i className={`ri-arrow-right-s-line ${sepClass}`} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}